export const FeeEscalationsFormTestIds = {
  FEE_ESCALATION_SELECT: 'fee-escalations-form.fee-escalation-select',
};
